import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicContractService {
  constructor(private http: PublicHttpClientService) {}

  getContract(contract_id: number | string): Observable<any> {
    return this.http
      .get(`/api/public/contracts/${contract_id}`)
      .pipe(tap((_) => console.log("PublicContractService.getContract: Ok.")));
  }

  getParams(id: number | string): Observable<any> {
    return this.http
      .get(`/api/public/contracts/${id}/status_params`)
      .pipe(tap((_) => console.log("PublicContractService.getParams: Ok.")));
  }

  saveVisitProgress(id: number | string, params: Record<string, unknown>): Observable<any> {
    return this.http
      .post(`/api/public/contracts/${id}/save_visit_progress`, params)
      .pipe(tap((_) => console.log("PublicContractService.saveVisitProgress: Ok.")));
  }

  notifySpecialist(id: number | string, params: Record<string, unknown>): Observable<any> {
    return this.http
      .post(`/api/public/contracts/${id}/contract_inconsistent_data`, params)
      .pipe(tap((_) => console.log("PublicContractService.notifySpecialist: Ok.")));
  }

  finishVisit(contract: { id: number | string }): Observable<any> {
    return this.http
      .post(`/api/public/contracts/${contract.id}/finish_visit`, { contract })
      .pipe(tap((_) => console.log("PublicContractService.finishVisit: Ok.")));
  }

  downloadContractAgain(id: number | string, sections?: string[]): Observable<any> {
    const options: any = { responseType: "blob" as "json" };
    if (sections !== undefined) {
      options.params = { "sections[]": sections };
    }
    return this.http
      .get(`/api/public/contracts/${id}/download_contract_again`, options)
      .pipe(tap((_) => console.log("PublicContractService.downloadContractAgain: Ok.")));
  }

  addDigitalSignatureIncident(id: number | string, params: Record<string, unknown>): Observable<any> {
    return this.http
      .post(`/api/public/contracts/${id}/add_digital_signature_incident`, params)
      .pipe(tap((_) => console.log("PublicContractService.addDigitalSignatureIncident: Ok.")));
  }

  updateContract(contract: any) {
    const options = {
      contract,
    };
    return this.http
      .put(`/api/public/contracts/${contract.id}`, options)
      .pipe(tap((_) => console.log("ContractService.updateContract: Ok.")));
  }
}
